import {
    AnimalsTask,
    translateAnimalAge,
    translateAnimalGender,
    translateAnimalsTaskType,
    translateAnimalType,
} from 'aos-services/src/services/tasks/types/task/AnimalsTask'
import { translateTrueFalse } from 'aos-services/src/services/tasks/types/task/BaseTask'
import { TaskTemplate } from 'aos-services/src/services/tasks/types/task/TaskTemplate'
import { PropsListEntry } from 'aos-ui/src/components/list/PropsList'
import { TFunction } from 'i18next'

export const animalsTaskPropertyList =
    (translate: TFunction) =>
    (t: AnimalsTask | TaskTemplate<AnimalsTask>): PropsListEntry[] => [
        [
            'tasks.task-preview.animal-task-type',
            t.animalTaskType ? translateAnimalsTaskType(translate)(t.animalTaskType) : '-',
        ],
        [
            'tasks.task-preview.animal-type',
            t.animalSpecies ? translateAnimalType(translate)(t.animalSpecies.animalType) : '-',
        ],
        ['tasks.task-preview.animal-species', t.animalSpecies?.label ?? '-'],
        ['tasks.task-preview.amount', t.amount],
        ['tasks.task-preview.cartridges', t.cartridges],
        ['tasks.task-preview.gender', t.gender ? translateAnimalGender(translate)(t.gender) : '-'],
        ['tasks.task-preview.age', t.lifeStage ? translateAnimalAge(translate)(t.lifeStage) : '-'],
        [
            'tasks.task-preview.horns',
            t.horns !== undefined && t.horns !== null
                ? translateTrueFalse(translate)(t.horns)
                : '-',
        ],
        ['tasks.task-preview.spike-amount', t.amountOfSpikes],
        ['tasks.task-preview.expulsions', t.expulsions],
    ]
